import { FaCheckCircle } from "react-icons/fa";
import ImgChoose from "../../common/images/whychooseux.png";
const WhyChooseUs = () => {
  return (
    <section className="max-w-[1280px]  mx-auto md:px-10 px-5 md:py-7 py-5 ">
      {/* Heading */}
      <h2 className="small:text-4xl text-3xl font-bold md:text-5xl text-center">

        Why Choose Us?
      </h2>
      <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
        <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
      </div>
      {/* Content Grid */}
      <div className="grid md:grid-cols-2 small:gap-10 gap-5  mt-10">
        {/* Image Section */}
        <div className="flex justify-start">
          {/* Tilted Background */}
          <img
            src={ImgChoose}
            alt="Why Choose Us?"
            className=" size-[90%] "
          />
        </div>

        {/* Text Content */}
        <div>
          <ul className="space-y-7 ">
            {[
              "Experienced team of designers and developers",
              "Custom designs tailored to your brand identity",
              "Mobile-first and responsive design",
              "Focus on performance and usability",
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-center pb-5 border-b-[1px] border-gray-300 space-x-3"
              >
                <FaCheckCircle className="text-yellow-400 text-4xl mt-[3px]" />
                <span className="text-lg text-gray-800">{item}</span>
              </li>
            ))}
          </ul>

          {/* CTA Section */}
          <p className="mt-6 text-gray-700 leading-relaxed">
            Let us help you create a user experience that leaves a lasting
            impression. <strong className="text-black">Contact us today</strong>{" "}
            to elevate your digital presence with expert UI/UX design!
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
